import React from 'react';

export interface SectionHeaderProps {
  children: React.ReactNode;
  level?: 1 | 2 | 3;
  className?: string;
  action?: React.ReactNode;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  children,
  level = 1,
  className = '',
  action,
}) => {
  // Level styles
  const levelStyles = {
    1: 'text-lg font-semibold text-neutral-900 mb-3', // 18px, main section headers
    2: 'text-base font-semibold text-neutral-900 mb-2', // 16px, subsection headers
    3: 'text-sm font-medium text-neutral-700 mb-2', // 14px, minor headers
  };

  const HeaderTag = level === 1 ? 'h2' : level === 2 ? 'h3' : 'h4';

  return (
    <div className={`flex items-center justify-between ${action ? 'mb-3' : ''}`}>
      <HeaderTag className={`${levelStyles[level]} tracking-tighter ${className}`.trim()}>
        {children}
      </HeaderTag>
      {action && <div>{action}</div>}
    </div>
  );
};

SectionHeader.displayName = 'SectionHeader';
